import React, { Component } from "react";
import axios from "axios";
import { ToastContainer } from "react-toastify";

import { BACKEND_CONFIG } from "../config/consts";
import { EditApplication } from "../pages/policy-actions/EditApplication";
import CarrierMessages from "../pages/carrier-messages/CarrierMessages";
import ServiceTransactionHeader from "../components/ServiceTransactionHeader";
import {
  RequoteProvider,
  RequoteConsumer,
} from "../context/quote-versioning-context";
import { QuoteSpinnerProvider } from "../context/quote-spinner-context";
import { SlideOutStatusProvider } from "../context/slide-out-status-context";
import { ActivityLogConsumer } from "../context/activity-log-context";
import xIcon from "../images/icon-outline-alert.svg";
import crossImg from "../images/xs.svg";

import ClientPanel from "./ClientPanel";
import PoliciesPanel from "./PoliciesPanel";
import CommunicationsPanel from "./CommunicationsPanel";
import ActionsPanel from "./ActionsPanel";
import LobDetails from "./lob-details/LobDetails";
import { Notes } from "./policy-notes/Notes";
import Requote from "./quote-versioning/Requote";

import "../styles/_fourPanel.scss";
import "../styles/success-fail.scss";

class FourPanel extends Component {
  constructor() {
    super();

    this.state = {
      clientId: "",
      showPolicyActions: false,
      showQuoteActions: false,
      showEditApplicationAction: false,
      //"Request Alternative E&S Quotes"
      showRequestExcessSurplusQuotes: false,
      excessSurplusQuotesRequested: false,
      showNotes: false,
      isEditApplicationVisible: false,
      isCarrierMessagesVisible: false,
      isVersioningSecondStepVisible: false,
      showErrorMessage: false,
      errorMessageTitle: "",
      error: "",
      quote: null,
    };

    this.hideLobDetails = this.hideLobDetails.bind(this);
    this.sortCards = this.sortCards.bind(this);
    this.viewNotes = this.viewNotes.bind(this);
    this.updatePolicyQuoteDetails = this.updatePolicyQuoteDetails.bind(this);
    this.closeErrorMessage = this.closeErrorMessage.bind(this);
    this.reloadPoliciesQuotes = this.reloadPoliciesQuotes.bind(this);
  }

  reloadPoliciesQuotes() {
    let clientId = this.props.match.params.clientId;
    let quoteIdToOpen = this.props.match.params.quoteIdToOpen;
    let selectedPolicyQuoteId = this.state.selectedPolicyQuoteId;

    axios
      .get(BACKEND_CONFIG.apiUrl + "panels/policiesquotes/" + clientId)
      .then((data) => {
        let hasPolicy = false;
        let hasQuotes = false;
        if (data.data && data.data.Cards) {
          for (let i = 0; i < data.data.Cards.length; i++) {
            if (data.data.Cards[i].Data.IsPolicy) {
              hasPolicy = true;
            } else {
              hasQuotes = true;
            }
          }
        }

        this.setState({
          policiesquotesData: data.data,
          showPolicyActions: hasPolicy,
          showQuoteActions: hasQuotes,
        });

        if (!quoteIdToOpen) {
          this.hideLobDetails();
        }

        if (
          quoteIdToOpen &&
          selectedPolicyQuoteId != quoteIdToOpen &&
          data.data.Cards.length
        ) {
          const quoteToView = data.data.Cards.map((c) => c.Data).find(
            (q) => q.PolicyQuoteId === quoteIdToOpen
          );

          if (quoteToView)
            this.viewPolicyQuoteDetails({
              policyQuoteId: quoteToView.PolicyQuoteId,
              isPolicy: quoteToView.IsPolicy,
              supportsVersioning: quoteToView.SupportsVersioning,
            });
        }
      });
  }

  closeErrorMessage() {
    this.setState({ showErrorMessage: false });
  }

  quoteVersioningVisible() {
    return BACKEND_CONFIG.get("quoteVersioningVisible");
  }

  allstateAgencyFeaturesAllowed() {
    return BACKEND_CONFIG.get("allstateAgencyFeaturesAllowed");
  }

  componentDidMount() {
    this.loadPage();
  }

  componentDidUpdate(prevProps) {
    if (prevProps.match.params.clientId !== this.props.match.params.clientId) {
      this.loadPage();
    }
  }

  loadPage() {
    this.setState({
      clientId: this.props.match.params.clientId,
    });

    axios
      .get(
        BACKEND_CONFIG.apiUrl +
          "allstateportalsettings/" +
          this.props.match.params.clientId
      )
      .then((data) => {
        this.setState({
          showEditApplicationAction: data.data.EditApplication,
          showRequestExcessSurplusQuotes: data.data.RequestExcessSurplusQuotes,
          excessSurplusQuotesRequested: data.data.ExcessSurplusQuotesRequested,
        });
      });

    axios
      .get(
        BACKEND_CONFIG.apiUrl +
          "panels/customer/" +
          this.props.match.params.clientId
      )
      .then((data) => {
        this.setState({ clientData: data.data });
      });

    this.reloadPoliciesQuotes();
  }

  showError(error) {
    this.setState({ error: error });
  }

  render() {
    return (
      <SlideOutStatusProvider>
        <div className="container-fluid min-1200 four-panel-root">
          {this.state.showNotes && (
            <div className="service-transaction-popup notes">
              <div className="background" />
              <div
                className="popup notes"
                style={{ width: "560px", minWidth: "560px" }}
              >
                <div
                  className="service-transactions-popup-header"
                  style={{ height: "75px", width: "480px" }}
                >
                  <div
                    className="close-icon"
                    onClick={() => {
                      this.setState({ showNotes: false });
                    }}
                  >
                    <img src={crossImg} alt="close" />
                  </div>
                  <div className="title">Notes</div>
                  <div className="delimeter" style={{ width: "500px" }} />
                </div>
                <div
                  className="popup-content"
                  style={{
                    position: "fixed",
                    height: "calc(100vh - 110px)",
                    width: "520px",
                    paddingRight: "24px",
                    paddingTop: "20px",
                    overflowY: "auto",
                    bottom: 0,
                  }}
                >
                  <Notes
                    policyId={this.state.currentPolicyId}
                    clientId={this.state.clientId}
                    quoteNumber={this.state.quoteNumber}
                    lob={this.state.lob}
                    closeNotes={() => this.setState({ showNotes: false })}
                    style={{ position: "relative" }}
                  />
                </div>
              </div>
            </div>
          )}
          {this.state.isEditApplicationVisible && (
            <EditApplication
              clientId={this.state.clientId}
              hideEditApplication={() =>
                this.setState({ isEditApplicationVisible: false })
              }
            />
          )}
          {this.state.isCarrierMessagesVisible && (
            <CarrierMessages
              clientId={this.state.clientId}
              quote={this.state.quote}
              hideCarrierMessages={() =>
                this.setState({ isCarrierMessagesVisible: false })
              }
            />
          )}
          {this.state.showErrorMessage && (
            <div className="service-request-submit mb-5">
              <div className="service-transaction-popup">
                <div className="background" />
                <div className="popup">
                  <div className="popup-content">
                    <ServiceTransactionHeader
                      title={this.state.errorMessageTitle}
                      hideInfo={true}
                      onClose={this.closeErrorMessage}
                    />
                    <div className="success-fail">
                      <img src={xIcon} alt="success" />
                      <h1>Oops!</h1>
                      <span>
                        There was an error completing your request. Please call
                        the Allstate Technology Support Center at{" "}
                        <b>800-729-3005</b> and press 2 for assistance with this
                        issue.
                      </span>
                      <div
                        style={{ cursor: "pointer" }}
                        className="btn btn-default"
                        onClick={() => {
                          this.setState({ showErrorMessage: false });
                        }}
                      >
                        Back to Client Details
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          )}
          <RequoteProvider>
            {this.quoteVersioningVisible() && (
              <RequoteConsumer>
                {(contextState) => {
                  this.startVesioning = contextState.startVersioning;

                  return (
                    contextState.isRequoteModalShown && (
                      <Requote
                        reload={this.reloadPoliciesQuotes}
                        versioningState={contextState.versioningState}
                        close={contextState.closeRequote}
                        showErrorMessage={(data) => {
                          this.setState({
                            showErrorMessage: true,
                            errorMessageTitle: data,
                          });
                        }}
                        hideLobDetails={this.hideLobDetails}
                      />
                    )
                  );
                }}
              </RequoteConsumer>
            )}
            <div className="row">
              <div className="col-3 four-panel-col">
                <ClientPanel data={this.state.clientData} />
              </div>
              <QuoteSpinnerProvider>
                <ActivityLogConsumer>
                  {(activityLogContext) => (
                    <div className="col-3 four-panel-col">
                      <PoliciesPanel
                        data={this.state.policiesquotesData}
                        viewCallback={(e) => this.viewPolicyQuoteDetails(e)}
                        viewNotesCallback={this.viewNotes}
                        hideLobDetails={this.hideLobDetails}
                        selectedPolicyQuoteId={this.state.selectedPolicyQuoteId}
                        sortCards={(a, b) => this.sortCards(a, b)}
                        reload={this.reloadPoliciesQuotes}
                        ready={activityLogContext.ready}
                        clientId={this.props.match.params.clientId}
                        loadClientNotifications={
                          activityLogContext.loadClientNotifications
                        }
                        showCarrierMessages={(data) => {
                          this.setState({
                            isCarrierMessagesVisible: true,
                            quote: data,
                          });
                        }}        
                      />
                    </div>
                  )}
                </ActivityLogConsumer>
                {this.renderThirdPanel()}
              </QuoteSpinnerProvider>
              <div className="col-3 four-panel-col">
                <ActionsPanel
                  showPolicyActions={this.state.showPolicyActions}
                  showEditApplication={() =>
                    this.setState({ isEditApplicationVisible: true })
                  }
                  requestAlternativeExcessSurplusQuotes={
                    this.requestAlternativeExcessSurplusQuotes
                  }
                  clientId={this.state.clientId}
                  showQuoteActions={this.state.showQuoteActions}
                  displayEditApplication={this.state.showEditApplicationAction}
                  displayRequestExcessSurplusQuotes={
                    this.state.showRequestExcessSurplusQuotes
                  }
                  excessSurplusQuotesRequested={
                    this.state.excessSurplusQuotesRequested
                  }
                  visible={this.allstateAgencyFeaturesAllowed()}
                />
              </div>
            </div>
          </RequoteProvider>
        </div>
        <ToastContainer theme="colored" />
      </SlideOutStatusProvider>
    );
  }

  renderThirdPanel() {
    if (this.state.selectedPolicyQuoteId) {
      return (
        <div className="col-3 four-panel-col">
          <RequoteConsumer>
            {(contextState) => (
              <LobDetails
                lobDetails={this.state.lobDetails}
                quoteWidgetData={this.state.quoteWidgetData}
                history={this.props.history}
                hideLobDetails={this.hideLobDetails}
                viewCallback={(e) => this.viewPolicyQuoteDetails(e)}
                selectedPolicyQuoteId={this.state.selectedPolicyQuoteId}
                onApplyBindRequest={this.props.onApplyBindRequest}
                quoteVersioningVisible={this.quoteVersioningVisible()}
                showCarrierMessages={(data) => {
                  this.setState({
                    isCarrierMessagesVisible: true,
                    quote: data,
                  });
                }}
                showErrorMessage={(data) => {
                  this.setState({
                    showErrorMessage: true,
                    errorMessageTitle: data,
                  });
                }}
                updatePolicyQuoteDetails={this.updatePolicyQuoteDetails}
                showRequote={contextState.showRequote}
                reload={this.reloadPoliciesQuotes}
                primaryContactInfo={this.getPrimaryContactInfo()}
                reloadQuoteDetails={(quoteId) =>
                  this.reloadQuoteDetails(quoteId)
                }
              />
            )}
          </RequoteConsumer>
        </div>
      );
    }

    return (
      <div className="col-3 four-panel-col">
        <CommunicationsPanel />
      </div>
    );
  }

  getPrimaryContactInfo() {
    let contact = this.state.clientData.Cards.find(
      (c) => c.Title === "Contacts"
    ).Data.Contacts.find((c) => c.PrimaryContact);

    let address = this.state.clientData.Cards.find(
      (c) => c.Title === "Addresses"
    ).Data.Addresses.find((c) => c.Primary);
    let dba = this.state.clientData.Cards.find((c) => c.Title === "Client").Data
      .DBA;

    return { ...contact, ...address, DBA: dba };
  }

  hideLobDetails() {
    this.setState({ selectedPolicyQuoteId: null });
  }

  sortCards(sortDirection, value) {
    if (this.state.policiesquotesData) {
      const data = this.state.policiesquotesData;
      switch (sortDirection) {
        case "asc":
          data.Cards = this.state.policiesquotesData.Cards.sort((a, b) => {
            if (a.Data[value] < b.Data[value]) {
              return -1;
            }
            if (a.Data[value] > b.Data[value]) {
              return 1;
            }
            return 0;
          });
          break;
        case "desc":
          data.Cards = this.state.policiesquotesData.Cards.sort((a, b) => {
            if (b.Data[value] < a.Data[value]) {
              return -1;
            }
            if (b.Data[value] > a.Data[value]) {
              return 1;
            }
            return 0;
          });
          break;
        default:
          break;
      }

      this.setState({ policiesquotesData: data });
    }
  }

  viewPolicyQuoteDetails(policyQuoteInfo) {
    this.hideLobDetails();

    let selectedPolicyQuoteId = policyQuoteInfo.policyQuoteId;
    let url = policyQuoteInfo.isPolicy
      ? BACKEND_CONFIG.apiUrl + "panels/policies/" + selectedPolicyQuoteId + "/details"
      : BACKEND_CONFIG.apiUrl + "panels/quotes/" + selectedPolicyQuoteId + "/details";

    axios({
      url: url,
      method: "get",
    }).then((data) =>
      this.setState({
        selectedPolicyQuoteId: selectedPolicyQuoteId,
        lobDetails: data.data,
      })
    );

    if (this.quoteVersioningVisible() && policyQuoteInfo.supportsVersioning) {
      this.startVesioning(selectedPolicyQuoteId);
    }
  }

  reloadQuoteDetails(quoteId) {
    axios({
      url: `panels/quotes/${quoteId}/details`,
      baseURL: BACKEND_CONFIG.apiUrl,
      method: "get",
    }).then((data) => {
      this.setState({ lobDetails: data.data });
    });
  }

  updatePolicyQuoteDetails(widgetId, state, value) {
    axios({
      url: `${BACKEND_CONFIG.apiUrl}versioning/updateWidget`,
      method: "post",
      data: JSON.stringify({
        WidgetId: widgetId,
        Values: [value],
        State: state,
      }),
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
      },
    }).then((data) => {
      this.setState({
        quoteWidgetData: data.data,
      });
    });
  }

  viewNotes(policyQuoteInfo, show) {
    this.setState({
      showNotes: show || true,
      currentPolicyId: policyQuoteInfo.policyQuoteId,
      quoteNumber: policyQuoteInfo.quoteNumber,
      lob: policyQuoteInfo.lob,
      showError: this.showError,
    });
  }
}

export default FourPanel;
